var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCupcake = function SvgCupcake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.191 13.875h13.617c4.256 0 4.256-7.5 0-7.5H3.191c-4.255 0-4.255 7.5 0 7.5zm.645 8.648a1 1 0 00.962.727h10.404a1 1 0 00.962-.727l1.56-5.5a1 1 0 00-.962-1.273H3.238a1 1 0 00-.962 1.273l1.56 5.5zM5.745 8.25h8.085c3.83 0 3.83-5.625 0-5.625S7.447 3.563 7.447.75c-5.532 0-5.532 7.5-1.702 7.5z",
    fill: "#1F1F1F"
  })));
};

export default SvgCupcake;